import { $axios } from "@/config/axios";

export default {
  // pgs will be repeated in the payload
  fetchPGsUsedInCurrCulture: function(pondId, params) {
    return $axios.get(`ponds/${pondId}/pond-guards-in-current-culture`, {
      params,
    });
  },
};
